<template>
  <article class="competency-card-skeleton" aria-hidden="true">
    <div class="competency-card-skeleton__heading">
      <span class="competency-card-skeleton__icon shimmer"></span>
      <span class="competency-card-skeleton__title shimmer"></span>
    </div>
    <span class="competency-card-skeleton__line shimmer"></span>
    <span class="competency-card-skeleton__line competency-card-skeleton__line--short shimmer"></span>
    <span class="competency-card-skeleton__line competency-card-skeleton__line--medium shimmer"></span>
    <div class="competency-card-skeleton__dates">
      <div>
        <span class="competency-card-skeleton__label shimmer"></span>
        <span class="competency-card-skeleton__value shimmer"></span>
      </div>
      <div>
        <span class="competency-card-skeleton__label shimmer"></span>
        <span class="competency-card-skeleton__value shimmer"></span>
      </div>
    </div>
    <span class="competency-card-skeleton__action shimmer"></span>
  </article>
</template>

<script>
export default {
  name: "CompetencyCardSkeleton",
};
</script>

<style scoped>
.competency-card-skeleton {
  display: flex;
  width: 100%;
  min-width: 0;
  min-height: 270px;
  flex-direction: column;
  padding: 22px;
  background: #fff;
  border: 1px solid #e6eaf0;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(37, 48, 68, 0.06);
  box-sizing: border-box;
  overflow: hidden;
}

.competency-card-skeleton__heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.competency-card-skeleton__icon {
  flex: 0 0 52px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.competency-card-skeleton__title {
  display: block;
  width: 68%;
  height: 18px;
  margin-top: 8px;
  border-radius: 6px;
}

.competency-card-skeleton__line {
  display: block;
  width: 100%;
  height: 12px;
  margin-top: 14px;
  border-radius: 6px;
}

.competency-card-skeleton__line:first-of-type {
  margin-top: 22px;
}

.competency-card-skeleton__line--short {
  width: 72%;
}

.competency-card-skeleton__line--medium {
  width: 88%;
}

.competency-card-skeleton__dates {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding-top: 14px;
  margin: auto 0 16px;
  border-top: 1px solid #eef0f4;
}

.competency-card-skeleton__label {
  display: block;
  width: 64px;
  height: 10px;
  margin-bottom: 8px;
  border-radius: 4px;
}

.competency-card-skeleton__value {
  display: block;
  width: 84px;
  height: 12px;
  border-radius: 4px;
}

.competency-card-skeleton__action {
  align-self: flex-end;
  width: 88px;
  height: 14px;
  border-radius: 4px;
}

.shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: competency-skeleton-loading 1.5s infinite;
}

@keyframes competency-skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 575px) {
  .competency-card-skeleton {
    min-height: 250px;
    padding: 16px;
  }

  .competency-card-skeleton__heading {
    gap: 10px;
  }

  .competency-card-skeleton__icon {
    flex-basis: 44px;
    width: 44px;
    height: 44px;
  }

  .competency-card-skeleton__title {
    width: 72%;
  }
}

@media (max-width: 639px) {
  .competency-card-skeleton {
    min-height: 0;
    padding: 16px;
    border-radius: 12px;
  }

  .competency-card-skeleton__dates {
    gap: 8px;
    margin-bottom: 12px;
  }

  .competency-card-skeleton__action {
    min-height: 20px;
  }
}
</style>
